import { combineReducers } from "redux";
import appReducer from "./appReducer";
import AsyncReducer from "../asyncLoading/AsyncReducer";
import approvalReducer from "./approvalReducer";
import authenticationReducer from "./authenticationReducer";
import corporateReducer from "./corporateReducer";
import feeCategoryReducer from "./feeCategoryReducer";
import holdingAccountReducer from "./holdingAccountReducer";
import issuerReducer from "./issuerReducer";
import paymentReducer from "./paymentReducer";
import permissionReducer from "./permissionReducer";
import roleReducer from "./roleReducer";
import superCorporateReducer from "./superCorporateReducer";
import stateReducer from "./stateReducer";
import userReducer from "./userReducer";
import thirdPartyBeneficiaryReducer from "./thirdPartyBeneficiaryReducer";
import globalParametersReducer from "./globalParametersReducer";
import cpayAppReducer from "./cpayAppReducer";
import settlementReducer from "./settlementReducer";
import { reducer as ToastrReducer } from "react-redux-toastr";
import entitySearchReducer from "./entitySearchReducer";
import securityQuestionReducer from "./securityQuestionReducer";

const baseReducer = combineReducers({
    appReducer,
    AsyncReducer,
    authenticationReducer,
    approvalReducer,
    corporateReducer,
    cpayAppReducer,
    entitySearchReducer,
    feeCategoryReducer,
    globalParametersReducer,
    holdingAccountReducer,
    issuerReducer,
    paymentReducer,
    permissionReducer,
    roleReducer,
    superCorporateReducer,
    securityQuestionReducer,
    settlementReducer,
    stateReducer,
    toastr: ToastrReducer,
    thirdPartyBeneficiaryReducer,
    userReducer
});

export default baseReducer;
